import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { eur } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/common";
import { MONTHS } from "@/components/previsionale/helpers";
import { Target, ArrowRight } from "lucide-react";

const n = (v) => Number(v || 0).toLocaleString("it-IT");

function YearBlock({ y }) {
  if (!y.has_target) return <div className="text-xs text-slate-400" data-testid={`nights-gap-${y.year}-none`}>{y.year}: nessun obiettivo impostato</div>;
  return (
    <div data-testid={`nights-gap-${y.year}`}>
      <div className="flex flex-wrap items-baseline gap-x-3 text-sm">
        <span className="font-semibold text-slate-800">{y.year} · obiettivo {eur(y.target)}</span>
        <span className="text-slate-500">netto prudente (confermate meno cancellazioni) {eur(y.netto_conf)}</span>
        <span className={`ml-auto font-bold ${y.notti_mancanti > 0 ? "text-rose-600" : "text-emerald-700"}`} data-testid={`nights-gap-${y.year}-total`}>
          {y.notti_mancanti > 0 ? `mancano ${n(y.notti_mancanti)} notti` : "obiettivo coperto"}
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5 mt-2">
        {y.months.map((m) => (
          <div key={m.month} data-testid={`nights-gap-${y.year}-m${m.month}`} title={`Obiettivo ${eur(m.target)} · confermato ${eur(m.netto_conf)} · ${n(m.free)} notti libere`}
            className={`min-w-[64px] rounded-md border px-2 py-1 text-center ${m.notti_mancanti === 0 ? "border-emerald-200 bg-emerald-50 text-emerald-700" : m.over ? "border-rose-300 bg-rose-50 text-rose-700" : "border-amber-200 bg-amber-50 text-amber-800"}`}>
            <div className="text-[10px] uppercase">{MONTHS[m.month - 1]}</div>
            <div className="text-sm font-bold tabular">{m.notti_mancanti === 0 ? "ok" : n(m.notti_mancanti)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function NightsGap() {
  const { isSuperAdmin: isAdmin } = useAuth();
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAdmin) return;
    api.get("/previsionale-nights-gap").then((r) => setD(r.data)).catch(() => {});
  }, [isAdmin]);
  if (!d) return null;
  return (
    <Card className="p-4 mb-6" data-testid="nights-gap-card">
      <div className="flex items-center gap-2 mb-3">
        <Target size={16} className="text-sky-700" />
        <span className="text-sm font-semibold text-slate-700">Notti mancanti per l'obiettivo (solo prenotazioni confermate)</span>
        <button data-testid="nights-gap-open" onClick={() => navigate("/previsionale")} className="ml-auto text-xs font-semibold text-sky-700 inline-flex items-center gap-1 hover:text-sky-900">Previsionale <ArrowRight size={13} /></button>
      </div>
      <div className="space-y-4">{d.years.map((y) => <YearBlock key={y.year} y={y} />)}</div>
      <p className="text-[11px] text-slate-400 mt-3">Notti da vendere in più in ogni mese per raggiungere la quota mensile dell'obiettivo, al prezzo medio previsto e al netto di commissioni e tasse. Rosso = più notti di quelle ancora libere.</p>
    </Card>
  );
}
